import { awsRum } from 'src/serviceClients/aws-rum/awsRum-Service';
import { ClientSideMetricsConstants } from 'src/constants/client-side-metrics-constants';

// What a FATAL event records about a failed call
export interface FatalEventData {
    // The call that failed
    UIAction?: string;
    // Its HTTP status, 0 for a call that got no answer
    ErrorStatus: number;
    // The message it failed with
    ErrorMessage?: string;
    // The warehouse the call was for
    Warehouse?: string;
    // The associate who made it
    Associate?: string;
    // The call's mode, when it has one
    Mode?: string;
}

// Records FATAL for any failed call, then FATAL.RIV.UserException for a 400, RIVBFFRequestHandler's
// USER_ERROR_STATUS_CODE, or FATAL.RIV for any other status
export const recordFatalEvents = (eventData: FatalEventData): void => {
    awsRum.recordEvent(ClientSideMetricsConstants.FATAL, eventData);
    awsRum.recordEvent(eventData.ErrorStatus === 400 ? ClientSideMetricsConstants.FATAL_RIV_USER_EXCEPTION
        : ClientSideMetricsConstants.FATAL_RIV, eventData);
};
